
import Vue from "vue";
import { PriceFrequencyType } from "@/models/payment/pricing";
import { PaymentService } from "@/services/payment-service";
import { Plan } from "@/utils/payments/plan";
import AppActivationCard from "@/components/account/ActivationCard.vue";
import { HttpError } from "../../utils/services/http-error";
import { AuthService } from "../../services/auth-service";
import { CompanyService } from "../../services/company-service";
import AppBillingAddressEdit from "@/components/account/BillingAddressEditCard.vue";
import { BillingAddress } from "@/models/billing-address";
import { ComputedPricing } from "@/models/payment/computed-pricing";
import AppBillingAddress from "@/components/account/BillingAddressCard.vue";
import { Tier } from "@/utils/payments/tiers";

export default Vue.extend({
	data() {
		return {
			price: null as ComputedPricing | null,
			plan: new Plan(),
			address: new BillingAddress(),
			editInvoiceAddress: false,
			ready: false,
			AuthService
		};
	},
	computed: {
		hasBillingAddress(): boolean {
			return this.AuthService.wfCompany.WfOfflineID != "";
		},
		canRenew():boolean{
			if (!this.price) return false;
			if (this.plan.tier == Tier.ENTERPRISE) return false;
			return true;
		}
	},
	methods: {
		async onBillingAddressUpdate(address:BillingAddress){
			this.address = address;
			this.editInvoiceAddress = false;
			await this.fetchPrice();
		},
		async fetchPrice(){
			if (!this.ready) return;
			try {
				this.price = await PaymentService.getExtendPricing();
			} catch (err) {
				let error = err as HttpError;
				if (!error.isNetworkError) {
					let shouldCancel = true;
					await this.$wf.dialog(error.getText(), this.$ct("common.ok"), this.$ct("common.error"), "warning");
					if (shouldCancel){
						this.$router.push("/account/price");
					}
				}
			}
		},
	},
	async created() {
		this.plan.tier = AuthService.wfCompany.Tier;
		this.plan.paymentFrequency = PriceFrequencyType.YEAR;
		if (!this.hasBillingAddress){
			this.editInvoiceAddress = true;
			this.ready = true;
			return;
		}
		try {
			this.address = await CompanyService.getBillingAddress();
		} catch (err) {
			let e = err as HttpError;
			if (e.key == "ID_IS_NOT_VALID") {
				e.dontShow = true;
			}
			this.ready = true;
			return;
		}
		this.ready = true;
		await this.fetchPrice();
	},
	components: {
		AppActivationCard,
		AppBillingAddressEdit,
		AppBillingAddress
	},
	i18nEx: {
		componentPrefix: "views.AccountActivate"
	},
});
